import { createAction, props } from '@ngrx/store';
import { Tab } from 'src/app/components/tabs/tabs.component';
import { IClientSettings } from 'src/app/core/models/agency-settings.model';
import { DOCSAConfirmation, DOCSADoc } from 'src/app/core/models/docsa.model';
import { EmergencyContactModel } from 'src/app/core/models/emergency-contact.model';
import { BrandZone } from 'src/app/core/models/fare-family.model';
import { IBookingData } from '../components/confirmation-step/confirmation-step.component';
import { Passenger, PnrInfo, QuoteRequest, WaiverData } from 'src/app/core/models/itinerary.model';
import { ContractError } from 'src/app/core/models/models';
import { AncillariesValidation } from 'src/app/core/models/special-requests.model';
import {
  ExchangeOptionFilter,
  IAncillariesWaiveQuote,
  InvoluntaryExchangeQuote
} from 'src/app/core/models/involuntary-change.model';
import {
  ExchangeAvailability,
  ExchangeAvailabilityOption,
  ExchangeQuoteRequest,
  ExchangeSegment
} from 'src/app/core/models/voluntary-change.model';
import { Price } from 'src/app/core/models/cancellation.model';

export const ForceRefreshSesionAndBook = createAction(
  '[Involuntary Change Page] Force refresh token in sesion before book',
  props<{ data: IBookingData }>()
);

export const clearInvoluntaryChange = createAction(
  '[Clear Involuntary change] Clear Involuntary Changes'
);

export const ChooseArlineOption = createAction(
  '[Involuntary Change Page] Choose Arline Option',
  props<{ waiverData: WaiverData }>()
);

export const ChangeActiveTab = createAction(
  '[Involuntary Change Page] Change Active Tab',
  props<{ activeTab: number }>()
);

export const LoadInvoluntaryQuoteSuccess = createAction(
  '[Involuntary Change Page] Load Involuntary Quote Success',
  props<{
    quote: InvoluntaryExchangeQuote;
    request: QuoteRequest;
    hasSplit: boolean;
    settings: IClientSettings;
  }>()
);

export const ChooseOtherAlternative = createAction(
  '[Involuntary Change Page] Choose other Alternative'
);

export const goToSeatmapNewFlow = createAction('[Involuntary Change Page] Go To Seat Map New Flow');

export const ChooseOtherAlternativeFromNewFlow = createAction(
  '[Involuntary Change Page] Choose other Alternative from New Flow'
);

export const ChooseExchangePricing = createAction(
  '[Involuntary Change Page] Choose exchange pricing'
);

export const ConfirmFare = createAction('[Involuntary Change Page] Confirm fare');

export const BackToAlternatives = createAction('[Involuntary Change Page] Back To Alternatives');

export const BackToNewFlowStep = createAction(
  '[Involuntary Change Page] Back To Confirmation Step'
);

export const BackToAlternativesNewFlowStep = createAction(
  '[Involuntary Change Page] Back To Confirmation Step from new flow'
);

export const SplitPnrStateReset = createAction('[Involuntary Change Page] Split pnr state reset');

export const EndSplit = createAction('[Involuntary Change Page] End Split');

export const RequestChangeAirlineRecommendation = createAction(
  '[Involuntary Change Page] Request Change Airline Recommendation',
  props<{ addData: IBookingData; isFromVoluntary: boolean }>()
);

export const RequestChangeAirlineRecommendationSuccess = createAction(
  '[Involuntary Change Page] Request Change Airline Recommendation Success',
  props<{ pnr: PnrInfo }>()
);

export const RequestChangeAirlineRecommendationFail = createAction(
  '[Involuntary Change Page] Request Change Airline Recommendation Success Error',
  props<{ error: ContractError }>()
);

export const LoadAvailabilitiesInvol = createAction(
  '[Involuntary Change Page] Load Availabilities Segunda Versión',
  props<{ exchangeSegments: ExchangeSegment[]; isNewFlow: boolean }>()
);

export const LoadingStart = createAction('[Involuntary Change Page] Start Loading ');

export const LoadAvailabilitesSuccess = createAction(
  '[Involuntary Change Page] Load Availabilities Success',
  props<{ availabilities: ExchangeAvailability }>()
);

export const LoadAvailabilitesPerSegmentSuccess = createAction(
  '[Involuntary Change Page] Load Availabilities Per Segment Success',
  props<{ availabilitiesPerSegment: ExchangeAvailability[] }>()
);

export const AddSelectedOption = createAction(
  '[Involuntary Change Page] Add Option Selected',
  props<{ selectedOption: ExchangeAvailabilityOption; index: number }>()
);

export const LoadAvailabilitesTabs = createAction(
  '[Involuntary Change Page] Load Availabilities Tabs',
  props<{ availabilitiesTabs: Tab[] }>()
);

export const LoadAvailabilitesError = createAction(
  '[Involuntary Change Page] Load Availabilities Error',
  props<{ error: ContractError }>()
);

export const loadingStop = createAction('[Involuntary Change Page] Stop Loading');

export const InvoluntaryBookRequestAPI = createAction(
  '[Involuntary Change Page] Involuntary Book Request API',
  props<{ data: IBookingData }>()
);

export const InvoluntaryBookSuccess = createAction(
  '[Involuntary Change Page] Involuntary Book Success',
  props<{ pnr: PnrInfo }>()
);

export const InvoluntaryBookFail = createAction(
  '[Involuntary Change Page] Involuntary Book Fail',
  props<{ error: ContractError }>()
);

export const InvoluntaryFinishBookRequest = createAction(
  '[Involuntary Change Page] Involuntary Finish Book Request API',
  props<{ quote: ExchangeQuoteRequest }>()
);

export const InvoluntaryFinishBookRequestFail = createAction(
  '[Involuntary Change Page] Involuntary Finish Book Request API Fail',
  props<{ error: ContractError }>()
);

export const ExchangeBookRequest = createAction(
  '[Exchange Change Page] Exchange Book Request',
  props<{ data: WaiverData }>()
);

export const ExchangeBookSuccess = createAction(
  '[Exchange Change Page] Exchange Book Success',
  props<{ pnr: PnrInfo }>()
);

export const ExchangeBookFail = createAction(
  '[Exchange Change Page] Exchange Book Fail',
  props<{ error: ContractError }>()
);

export const Filter = createAction(
  '[Involuntary Change Page] Adding Filter options',
  props<{ filter: ExchangeOptionFilter; index: number }>()
);

export const SetIsReIssueRequired = createAction(
  '[Involuntary Change Page] Set IsReIssue Requeried',
  props<{ isReIssueRequired: boolean }>()
);

export const DocsaSave = createAction(
  '[Involuntary Change Page] Docsa Save',
  props<{ docs: DOCSADoc[] }>()
);

export const MLSave = createAction('[Involuntary Change Page]  ML');

export const EmergencyContact = createAction(
  '[Involuntary Change Page] Emergency Contact',
  props<{ contact: EmergencyContactModel[] }>()
);

export const DocsaRequest = createAction('[Involuntary Change PAge] Docsa Request');

export const DocsaRequestSuccess = createAction(
  '[Involuntary Change PAge] Docsa Request Success',
  props<{ docsaConfirmation: DOCSAConfirmation }>()
);

// SeatMap
export const GoToSeatMap = createAction('[Involuntary Change Page] Go to Seat Map Step');

// End SeatMap

export const GoToDocsa = createAction('[Involuntary Change Page] Go to Docsa Step');

export const goToEmergencyContact = createAction(
  '[Involuntary Change Page] Go to Emergency Conctact'
);

export const goToAditionalInformation = createAction(
  '[Involuntary Change Page] Go to Aditional Information'
);

export const GoToConfirmation = createAction('[Involuntary Change Page] Go to Confirmation Step');

export const ReturnToStep1 = createAction('[Involuntary Change Page] return To Step 1');

export const InvoluntaryChangeFail = createAction(
  '[Involuntary Change Page] Voluntary Change Fail',
  props<{ involuntaryChangeError: ContractError; docsaFail: boolean }>()
);

export const DoNothing = createAction('[Involuntary Change Page] Do Nothing');

export const ExchangePricingRequest = createAction(
  '[Involuntary Change Page] Exchange Pricing Request',
  props<{ fromVoluntary: boolean }>()
);

export const ExchangePricingSuccess = createAction(
  '[Involuntary Change Page] Exchange Pricing Success',
  props<{ exchangePricing: ExchangeAvailabilityOption }>()
);

export const ExchangePricingWithoutAISuccess = createAction(
  '[Involuntary Change Page] Exchange Pricing Success with out AI',
  props<{ exchangePricing: ExchangeAvailabilityOption; settings: IClientSettings }>()
);

export const ExchangeIASuccess = createAction('[Involuntary Change Page] Exchange AI Success');

export const ExchangeIAFail = createAction('[Involuntary Change Page] Exchange AI Fail');

export const ExchangePricingFail = createAction(
  '[Involuntary Change Page] Exchange Pricing Fail',
  props<{ error: ContractError }>()
);

export const ExchangeBook = createAction(
  '[Involuntary Change Page] Involuntary Exchange Book Request',
  props<{ data: WaiverData }>()
);

export const ChangeStepsNewFlow = createAction(
  '[Involuntary Change Page] Involuntary Change Steps',
  props<{ isReIssueActive: boolean }>()
);

export const LoadFareFamiliesInvoluntary = createAction(
  '[Involuntary Change Page] Load FareFamilies',
  props<{ option: ExchangeAvailabilityOption; index: number; open: boolean }>()
);

export const LoadFareFamiliesSuccess = createAction(
  '[Involuntary Change Page] Load FareFamilies Success',
  props<{ zones: BrandZone[] }>()
);

export const LoadFareFamiliesFail = createAction(
  '[Involuntary Change Page] Load FareFamilies Fail',
  props<{ error: ContractError }>()
);

export const SaveCommission = createAction(
  '[Involuntary Change Page] Save Commission ',
  props<{ value: number }>()
);

export const SaveIsNewFlow = createAction(
  '[Involuntary Change Page] Save Is NewFlow Value ',
  props<{ value: boolean }>()
);

export const LoadAncillariesComparison = createAction(
  '[Involuntary Change Page] Load Ancillaries Comparison',
  props<{ passengers: Passenger[]; option: ExchangeAvailabilityOption }>()
);

export const LoadAncillariesComparisonSuccess = createAction(
  '[Involuntary Change Page] Load Ancillaries Comparison Success',
  props<{ ancillariesValidation: AncillariesValidation[] }>()
);

export const LoadAncillariesComparisonFail = createAction(
  '[Involuntary Change Page] Load Ancillaries Comparison Fail',
  props<{ error: ContractError }>()
);

export const CloseAncillariesModal = createAction(
  '[Involuntary Change Page] Close Ancillarfies Modal'
);

export const LoadAncillariesSegments = createAction(
  '[Involuntary Change Page] Load Ancillaries Comparison per segment',
  props<{ passengers: Passenger[] }>()
);

export const LoadAncillariesSegmentsSuccess = createAction(
  '[Involuntary Change Page] Load Ancillaries Comparison per segment Success',
  props<{ passengers: Passenger[][] }>()
);

export const LoadAncillariesSegmentsFail = createAction(
  '[Involuntary Change Page] Load Ancillaries Comparison per segment Fail',
  props<{ error: ContractError }>()
);

export const AncillariesWaiveRequired = createAction(
  '[Involuntary Change Page] AncillariesWaive is required'
);

export const AncillariesWaive = createAction(
  '[Involuntary Change Page] AncillariesWaive quote request',
  props<{ quote: IAncillariesWaiveQuote }>()
);

export const AncillariesWaiveSuccess = createAction(
  '[Involuntary Change Page] AncillariesWaive quote request Success'
);

export const AncillariesWaiveFail = createAction(
  '[Involuntary Change Page] AncillariesWaive quote request Fail',
  props<{ error: ContractError }>()
);

export const ResetAncillariesWaiveState = createAction(
  '[Involuntary Change Page] Reset AncillariesWaive to initial state'
);

export const ChangeToAutomatic = createAction('[Involuntary Change Page] Change to Automatic Flow');

export const UpdatePricingQuoteRequestWithSeatPrices = createAction(
  '[Involuntary Change Page] Update the pricing quote request with seat information',
  props<{ prices: Price[] }>()
);

export const GoToSplitStepNewFlow = createAction(
  '[Involuntary Change Page] Go To Split Step New Flow'
);
